import React from 'react';
import { GithubIcon, LinkedinIcon, MailIcon } from 'lucide-react';

const socialLinks = [
  { name: 'Email', icon: MailIcon, href: 'mailto:souravghai96@gmail.com' },
  { name: 'GitHub', icon: GithubIcon, href: 'https://github.com/sourav15102' },
  { name: 'LinkedIn', icon: LinkedinIcon, href: 'https://www.linkedin.com/in/sghai96' },
];

const ContactMe = () => {
  return (
    <footer id="contact" className="border-t border-gray-200">
      <div className="container py-8 flex items-center justify-between flex-wrap gap-4">
        <p className="text-sm text-gray-500">Toronto, Canada</p>
        <div className="flex items-center gap-5">
          {socialLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-sm text-gray-700 hover:text-black hover:underline"
            >
              <link.icon className="h-4 w-4" />
              {link.name}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default ContactMe;
